export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-sparkling-2-line',
      title: 'Éclat instantané',
      description: 'Peau visiblement plus lumineuse dès la première séance'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Stimulation naturelle',
      description: 'Active les processus naturels de régénération cutanée'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Sans douleur',
      description: 'Technologie douce et aucune injection'
    },
    {
      icon: 'ri-time-line',
      title: 'Résultats durables',
      description: 'Effets progressifs et visibles sur plusieurs semaines'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-rose-50 via-white to-blush-50">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-light text-gray-900 mb-4">
              Pourquoi choisir le <span className="font-semibold text-rose-500">plasma froid</span> ?
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 text-center border border-rose-100 hover:border-rose-300 hover:shadow-lg transition-all duration-300">
                <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-rose-100 rounded-full">
                  <i className={`${benefit.icon} text-3xl text-rose-500`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
